import { FormList } from '../../types/form-list';

export type NotificationFormListState = Readonly<{
    [key: string]: FormList | undefined;
}>;

export const initialNotificationFormListState: NotificationFormListState = {};
